import { useQuery } from "@tanstack/react-query";
import { fetchCidadeBySlug } from "../city-slug";

export type SlugCityParam = {
  slug: string;
  enabled?: boolean;
};

export function useCidadeBySlug({ enabled, slug }: SlugCityParam) {
  const query = useQuery({
    queryKey: ["cidade-unica", slug],
    queryFn: async () => fetchCidadeBySlug({ slug }),
    enabled: enabled,
  });

  const response = query?.data?.data;

  return {
    response,
    ...query,
  };
}
